import { InjectionToken } from '@angular/core';

export const WISHLIST_RESERVATION_TERMS_URL = new InjectionToken<string | null>(
  'Wishlist reservation terms URL',
  { providedIn: 'root', factory: (): null => null },
);
